import {
  addObj,
  getAll,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  closeAll,
  batchAddObj
} from '@/api/sendcmdserv'

export default {
  state: {
    state_SendCmd_AddObjResult: null,
    state_SendCmd_GetAllResult: null,
    state_SendCmd_GetPageResult: null,
    state_SendCmd_GetDetailResult: null,
    state_SendCmd_ModifyObjResult: null,
    state_SendCmd_DeleteObjResult: null,
    state_SendCmd_CloseAllResult: null,
    state_SendCmd_BatchAddObjResult: null
  },
  mutations: {
    SET_SENDCMD_ADDOBJ_RESULT: (state, rst) => {
      state.state_SendCmd_AddObjResult = rst
    },
    SET_SENDCMD_GETALL_RESULT: (state, rst) => {
      state.state_SendCmd_GetAllResult = rst
    },
    SET_SENDCMD_GETPAGE_RESULT: (state, rst) => {
      state.state_SendCmd_GetPageResult = rst
    },
    SET_SENDCMD_GETDETAIL_RESULT: (state, rst) => {
      state.state_SendCmd_GetDetailResult = rst
    },
    SET_SENDCMD_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_SendCmd_ModifyObjResult = rst
    },
    SET_SENDCMD_DELETEOBJ_RESULT: (state, rst) => {
      state.state_SendCmd_DeleteObjResult = rst
    },
    SET_SENDCMD_CLOSEALL_RESULT: (state, rst) => {
      state.state_SendCmd_CloseAllResult = rst
    },
    SET_SENDCMD_BATCHADDOBJ_RESULT: (state, rst) => {
      state.state_SendCmd_BatchAddObjResult = rst
    }
  },
  actions: {
    SendCmdServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_SENDCMD_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_SENDCMD_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    SendCmdServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_SENDCMD_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_SENDCMD_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    SendCmdServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_SENDCMD_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_SENDCMD_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    SendCmdServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_SENDCMD_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_SENDCMD_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    SendCmdServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_SENDCMD_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_SENDCMD_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    SendCmdServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_SENDCMD_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_SENDCMD_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    SendCmdServ_CloseAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        closeAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_SENDCMD_CLOSEALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_SENDCMD_CLOSEALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    SendCmdServ_BatchAddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchAddObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_SENDCMD_BATCHADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_SENDCMD_BATCHADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_SendCmd_AddObjResult: state => {
      return state.state_SendCmd_AddObjResult
    },
    get_SendCmd_GetAllResult: state => {
      return state.state_SendCmd_GetAllResult
    },
    get_SendCmd_GetPageResult: state => {
      return state.state_SendCmd_GetPageResult
    },
    get_SendCmd_GetDetailResult: state => {
      return state.state_SendCmd_GetDetailResult
    },
    get_SendCmd_ModifyObjResult: state => {
      return state.state_SendCmd_ModifyObjResult
    },
    get_SendCmd_DeleteObjResult: state => {
      return state.state_SendCmd_DeleteObjResult
    },
    get_SendCmd_CloseAllResult: state => {
      return state.state_SendCmd_CloseAllResult
    },
    get_SendCmd_BatchAddObjResult: state => {
      return state.state_SendCmd_BatchAddObjResult
    }
  }
}
